import { Sparkles, Target, Network } from "lucide-react";
import Section from "@/components/editorial/Section";
import Eyebrow from "@/components/editorial/Eyebrow";
import Button from "@/components/editorial/Button";
import SponsorStrip from "@/components/editorial/SponsorStrip";
import { EDITORIAL_IMAGES } from "@/data/content";

const PILLARS = [
  {
    icon: Sparkles,
    title: "Narrativa premium",
    desc: "Producción editorial con estándares documentales, no branded content.",
  },
  {
    icon: Target,
    title: "Propósito auténtico",
    desc: "Asociación con causas reales: equidad, economía local, comunidad.",
  },
  {
    icon: Network,
    title: "Comunidad curada",
    desc: "Acceso directo a una red de mujeres líderes, lectoras y aliadas.",
  },
];

export default function Sponsor() {
  return (
    <Section tone="charcoal" padding="xl" testid="sponsor-section" id="brands">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <div className="relative aspect-[4/3] overflow-hidden rounded-sm">
            <img
              src={EDITORIAL_IMAGES.sponsor}
              alt="Screening privado de marcas patrocinadoras"
              loading="lazy"
              decoding="async"
              width="1536"
              height="1024"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-charcoal/20" />
          </div>
        </div>

        <div className="lg:col-span-6">
          <Eyebrow tone="gold" className="mb-5">
            Para marcas
          </Eyebrow>
          <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.25rem,4.5vw,4rem)] text-cream">
            Conecta tu marca con<br />
            <span className="italic text-gold">las historias que están<br />cambiando México.</span>
          </h2>
          <div className="mt-8 space-y-4 text-[17px] leading-relaxed text-cream/80 max-w-xl">
            <p>
              Nuestras colaboraciones no son banners. Son episodios, eventos y
              activaciones diseñadas junto a tu equipo, integradas en el
              storytelling, con distribución propia en video, audio y
              comunidad.
            </p>
            <p>
              Patrocinar Mujeres Motor es asociar tu marca a mujeres reales y
              a propósitos verificables en México.
            </p>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {PILLARS.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="border-t border-cream/15 pt-5">
                <Icon className="h-5 w-5 text-gold mb-3" strokeWidth={1.25} />
                <p className="font-serif text-lg text-cream">{title}</p>
                <p className="text-sm text-cream/60 mt-1 leading-snug">{desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5">
            <Button to="/for-brands" variant="primary" data-testid="sponsor-cta">
              Agenda una presentación
            </Button>
            <p className="text-xs text-cream/60 leading-relaxed max-w-xs">
              <span className="text-gold">●</span> 3 marcas fundadoras ya
              confirmadas para temporada 2026.
            </p>
          </div>
        </div>
      </div>

      {/* Partner strips */}
      <div className="mt-20 pt-12 border-t border-cream/10 space-y-14">
        <SponsorStrip
          tier="founding"
          eyebrow="Founding Partners 2026"
          tone="dark"
          size="lg"
          centered
          testid="home-founding-strip"
        />
        <SponsorStrip
          tier="content"
          eyebrow="Aliados editoriales"
          tone="dark"
          size="md"
          centered
          testid="home-content-strip"
        />
      </div>
    </Section>
  );
}
